import {FieldDataType} from "../../../generated/api/base";
import type {AppState} from "../../state/AppState";
import type {BoundarySpaceMap} from "../BoundarySpaceMap";
import type {IModel} from "../Model";
import type {Field, IFieldPointer} from "./Field";
import type {ListObject} from "./datatypes/SingleSelect";

/** Resolves one field-based Spotlight rule; priority between rules is handled by the caller. */
export function getFieldSpotlightColor(item: IModel, fieldRefId: IFieldPointer, appState: AppState): string | null {
	const {actions} = appState;
	const field = actions.getFieldByRefId(fieldRefId);
	if (!field || field.dataType !== FieldDataType.SingleChoiceList) {
		return null;
	}

	if (!field.default) {
		const mapping = appState.typeFieldMapping[field.feature];
		if (!mapping || !Object.values(mapping).some((fieldSet) => fieldSet.has((field as Field).id))) {
			return null;
		}
	}

	const model = (item as BoundarySpaceMap).isBoundarySpaceMap ? (item as BoundarySpaceMap).parent : item;
	const choices: ListObject[] = field.dataTypeSettings?.choiceList || [];
	const colorForValue = (value: unknown): string | null => {
		if (value == null || value === "") {
			return null;
		}
		const color = choices.find((choice) => choice.value === value)?.color?.trim();
		return color ? (color.startsWith("#") ? color : `#${color}`) : null;
	};

	const ownValue = actions.getOwnFieldValue(model, fieldRefId);
	// An assigned value keeps priority even when its option has been removed or has no color.
	if (ownValue != null && ownValue !== "") {
		return colorForValue(ownValue);
	}

	// Use the same propagation order as Lists and Details, including server-provided linked values.
	for (const propagation of actions.getFieldPropagations(model, field)) {
		const color = colorForValue(propagation.value);
		if (color) {
			return color;
		}
	}
	return null;
}
